import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { CrudGenericsService } from '../common/crud-generics';
import { Environment, ModelNumStrNav, TicketsAllerta, ITicketsAllerta_TableModel } from '../../models/-index';
import { Observable } from 'rxjs';

@Injectable()
export class TicketsAllertaService extends CrudGenericsService<TicketsAllerta, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/TicketsAllerta`);
    this.base = `${env.apiUrl}/api/TicketsAllerta/`;
  }
  public GetTicketsAllerta_TableModel(): Observable<ITicketsAllerta_TableModel[]> {
    const url = this.base + 'GetTicketsAllerta_TableModel';
    return this.http.get<ITicketsAllerta_TableModel[]>(`${url}`);
  }
  // per add
  public Get4Select_TipoNavigation(): Observable<ModelNumStrNav[]> {
    const url = this.base + 'Get4Select_TipoNavigation';
    return this.http.get<ModelNumStrNav[]>(`${url}`);
  }
  // per ionic specifica filtro Tipo APP
  public Get4SelectForApp_TipoNavigation(): Observable<ModelNumStrNav[]> {
    const url = this.base + 'Get4SelectForApp_TipoNavigation';
    return this.http.get<ModelNumStrNav[]>(`${url}`);
  }
}
